// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/common/error.proto (package infinigence.infini.agentplatform.common, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/common/error.proto.
 */
export const file_agentplatform_common_error: GenFile = /*@__PURE__*/
  fileDesc("CiBhZ2VudHBsYXRmb3JtL2NvbW1vbi9lcnJvci5wcm90bxInaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0uY29tbW9uIvoCCglFcnJvckRhdGESUwoGcmVhc29uGAEgASgJQkO6R0A6DBIKIk5vdEZvdW5kIpICL+ivreS5ieWMluWOn+WboO+8jOeUqOS6jiBjbGllbnQg56uv5YiG5pSv6YC76L6REj4KB21lc3NhZ2UYAiABKAlCLbpHKjoTEhEi6LWE5rqQ5LiN5a2Y5ZyoIpICEueUqOaIt+WPr+ivu+a2iOaBrxKMAQoIbWV0YWRhdGEYAyADKAsyQC5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS5jb21tb24uRXJyb3JEYXRhLk1ldGFkYXRhRW50cnlCOLpHNZICMumZhOWKoOS4iuS4i+aWh++8iOWmgiBmaWVsZCDlkI3jgIF0ZW5hbnRfaWQg562J77yJGi8KDU1ldGFkYXRhRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4AToYukcVkgIS5YW35L2T6ZSZ6K+v5L+h5oGvIpEBCgtFcnJvckRldGFpbBIMCgRjb2RlGAEgASgFEhMKC3N0YXR1c19jb2RlGAIgASgFEkAKBGRhdGEYAyABKAsyMi5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS5jb21tb24uRXJyb3JEYXRhEg0KBWNhdXNlGAQgAygJEg4KBm9yaWdpbhgFIAEoCUJRWk9naXRsYWIuaW5maW5pLWFpLmNvbS9taXphci9pbmZpbmlhaS1hZ2VudGljLWluZnJhL2NvbW1vbi9ncnBjYXBpcy9jb21tb247Y29tbW9uYgZwcm90bzM", [file_gnostic_openapi_v3_annotations]);

/**
 * ErrorData 描述具体错误信息。
 *
 * 它是全系统统一的错误负载：既作为 httpv2.ErrorResponse 的 data，
 * 也作为内部 RPC（bizerr.ErrorDetail）的错误详情，保证同一个错误在 HTTP 边界
 * 与内部服务之间的字段语义完全一致。
 *
 * @generated from message infinigence.infini.agentplatform.common.ErrorData
 */
export type ErrorData = Message<"infinigence.infini.agentplatform.common.ErrorData"> & {
  /**
   * 语义化原因，用于 client 端分支逻辑
   * @gotags: json:"reason"
   *
   * @generated from field: string reason = 1;
   */
  reason: string;

  /**
   * 用户可读消息
   * @gotags: json:"message"
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * 附加上下文（如 field 名、tenant_id 等）
   * @gotags: json:"metadata,omitempty"
   *
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message infinigence.infini.agentplatform.common.ErrorData.
 * Use `create(ErrorDataSchema)` to create a new message.
 */
export const ErrorDataSchema: GenMessage<ErrorData> = /*@__PURE__*/
  messageDesc(file_agentplatform_common_error, 0);

/**
 * ErrorDetail 是 bizerr.Error 的内部 RPC 投影，随 gRPC status details 传输。
 *
 * 它与 HTTP 边界共用 ErrorData（reason / message / metadata），保证同一个错误
 * 在 HTTP 与内部 RPC 之间字段语义完全一致；内部服务互信，故额外携带 cause 链
 * 与 origin，且 message / metadata 不脱敏。调用栈不上 wire——产生方把栈打进
 * 自己的日志，接收方按 trace_id 关联。
 *
 * @generated from message infinigence.infini.agentplatform.common.ErrorDetail
 */
export type ErrorDetail = Message<"infinigence.infini.agentplatform.common.ErrorDetail"> & {
  /**
   * bizerr.Code，业务错误的全局唯一标识
   *
   * @generated from field: int32 code = 1;
   */
  code: number;

  /**
   * HTTP 状态码，由产生方 Define 声明；接收方据此还原 Error.StatusCode
   *
   * @generated from field: int32 status_code = 2;
   */
  statusCode: number;

  /**
   * 对外三元组：reason / message / metadata
   *
   * @generated from field: infinigence.infini.agentplatform.common.ErrorData data = 3;
   */
  data?: ErrorData | undefined;

  /**
   * 摊平的根因链，每层一条，最多 16 层
   *
   * @generated from field: repeated string cause = 4;
   */
  cause: string[];

  /**
   * 产生该错误的服务名
   *
   * @generated from field: string origin = 5;
   */
  origin: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.common.ErrorDetail.
 * Use `create(ErrorDetailSchema)` to create a new message.
 */
export const ErrorDetailSchema: GenMessage<ErrorDetail> = /*@__PURE__*/
  messageDesc(file_agentplatform_common_error, 1);

